// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"dc67eef3","321":"904cdbdf","990":"904cdbdf"}[chunkId] + ".chunk.css";
};